"use strict";

import { heroOut, heroIn, projIn, projOut, projChange } from "../animations";
import color from "./update-color";
import { navReusables } from "./nav-interactions";
import generateCounter from "./slide-counter";
import gsap from "gsap";
import { Observer } from "gsap/all";

const homeInteractions = function (sec) {
	const homeContainer = document.querySelector(".home"),
		heroSection = homeContainer.querySelector(".section__hero"),
		scrollDwnBtn = homeContainer.querySelector(".scroll-down"),
		projContainer = homeContainer.querySelector(".section__projects"),
		counter = projContainer.querySelector(".slide-counter"),
		homeIcon = counter.querySelector("#home"),
		projects = projContainer.querySelectorAll(".project");

	const colors = Array.from(projects).map((p) => p.getAttribute("data-color"));
	const pLgth = projects.length;
	const counters = generateCounter(counter, pLgth);

	let atStart = true,
		isAnimating,
		currSec = sec,
		currProj = 0,
		prevProj;

	color(currProj, [counters, projContainer, homeIcon], colors);
	navReusables.secListener("add");

	/* const scrollIx = (e) => {
		e.preventDefault();

		homeContainer.removeEventListener("wheel", scrollIx, { passive: false });

		if (e.deltaY > 0) {
			if (currSec === "hero") {
				heroOut(heroSection);
				projIn(projects[currProj]);
				navReusables.toggleNav();
				navReusables.mainListener("add");
				currSec = "projects";
			} else if (currSec === "projects" && currProj < pLgth - 1) {
				atStart = false;
				prevProj = currProj;
				currProj += 1;
				projChange(currProj, prevProj);
				color(currProj, [counters, projContainer, homeIcon], colors);
			}
		}

		if (e.deltaY < 0) {
			if (currSec === "projects" && atStart) {
				projOut(projects[currProj]);
				heroIn(heroSection);
				navReusables.toggleNav();
				navReusables.mainListener("remove");
				currSec = "hero";
			} else if (currSec === "projects" && currProj !== 0) {
				atStart = false;
				prevProj = currProj;
				currProj -= 1;
				projChange(currProj, prevProj);
				color(currProj, [counters, projContainer, homeIcon], colors);

				if (currProj === 0) atStart = true;
			}
		}

		setTimeout(() => {
			homeContainer.addEventListener("wheel", scrollIx, { passive: false });
		}, 900);
	}; */

	const goToProj = function (e) {
		heroOut(heroSection);
		projIn(projects[currProj]);
		navReusables.toggleNav();
		navReusables.mainListener("add");
		currSec = "projects";
	};

	const nxtProj = (e) => {
		const el = e.target.tagName === "path" ? e.target.parentElement : e.target;

		if (el.id === "home") {
			projOut(projects[currProj]);
			heroIn(heroSection);
			navReusables.toggleNav();
			navReusables.mainListener("remove");
			currSec = "hero";
		} else {
			atStart = el.id === "1" ? true : false;
			prevProj = currProj;
			currProj = parseInt(el.id) - 1;

			projChange(currProj, prevProj);
			color(currProj, [counters, projContainer, homeIcon], colors);
		}
	};

	// homeContainer.addEventListener("wheel", scrollIx, { passive: false });
	scrollDwnBtn.addEventListener("click", goToProj);
	Array.from(counter.children).forEach((el) => {
		el.addEventListener("click", nxtProj);
	});

	/* GSAP observe plugin for scroll interactions */
	gsap.registerPlugin(Observer);

	const goUp = () => {
		if (currSec === "projects" && atStart) {
			isAnimating = true;
			projOut(projects[currProj]);
			heroIn(heroSection).then(() => {
				isAnimating = false;
			});
			if (window.matchMedia("(min-width: 1025px)").matches) navReusables.toggleNav();
			navReusables.mainListener("remove");
			currSec = "hero";
		} else if (currSec === "projects" && currProj !== 0) {
			isAnimating = true;
			atStart = false;
			prevProj = currProj;
			currProj -= 1;
			projChange(currProj, prevProj).then(() => {
				isAnimating = false;
			});
			color(currProj, [counters, projContainer, homeIcon], colors);

			if (currProj === 0) atStart = true;
		}
	};

	const goDown = () => {
		if (currSec === "hero") {
			isAnimating = true;
			heroOut(heroSection);
			projIn(projects[currProj]).then(() => {
				isAnimating = false;
			});
			if (window.matchMedia("(min-width: 1025px)").matches) navReusables.toggleNav();
			navReusables.mainListener("add");
			currSec = "projects";
		} else if (currSec === "projects" && currProj < pLgth - 1) {
			isAnimating = true;
			atStart = false;
			prevProj = currProj;
			currProj += 1;
			projChange(currProj, prevProj).then(() => {
				isAnimating = false;
			});
			color(currProj, [counters, projContainer, homeIcon], colors);
		}
	};

	Observer.create({
		target: homeContainer,
		type: "wheel",
		onUp: () => !isAnimating && goUp(),
		onDown: () => !isAnimating && goDown(),
		preventDefault: true,
		tolerance: 500,
	});

	Observer.create({
		target: homeContainer,
		type: "touch, scroll",
		onDown: () => !isAnimating && goUp(),
		onUp: () => !isAnimating && goDown(),
		preventDefault: true,
		tolerance: 10,
	});
};

export default homeInteractions;
